import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
interface BoxRowProps {
  left: string;
  right: string | ReactNode;
}
export const BoxRow = props => {
  const $ = _c(7);
  const {
    left,
    right
  } = props;
  let t0;
  if ($[0] !== left) {
    t0 = <p>{left}</p>;
    $[0] = left;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== right) {
    t1 = <p className="text-right font-semibold">{right}</p>;
    $[2] = right;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="flex flex-col gap-4 rounded-2xl lg:rounded-3xl"><div className="flex flex-row items-center justify-between gap-4">{t0}{t1}</div></div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};